import React from "react";
import { Button, Input, Card, CardBody } from "reactstrap";
import ReactTable from "react-table";
import {
  displayDefaultDateFormater,
  mustBeArray,
} from "../../utils/lib";
import UrgentDeliveryDisclaimer from "../Common/UrgentDeliveryDisclaimer";
import {BASE_URL, IsNullOrUndefined, SHORT_DATE_FORMAT} from "../../constants";
import moment from "moment";

const UrgentDeliveries = ({
  handleSelection,
  list,
  selectedDelivery,
  handleTermsAgreementChange,
  conditionAgreed,
  loading,
  driverRuns,
}) => {
  const getButtonClassName = (id) => {
    if (selectedDelivery && selectedDelivery !== id) return "bg-faded";
    return "bg-danger";
  };

  const getRunUrl = (runId) =>{
    // if the runId is in the drivers runs, then use the drivers url, otherwise use the search url
    const driverRun = driverRuns.items.find(x => x.id === parseInt(runId));

    let preFix = IsNullOrUndefined(driverRun) ? "search" : "driver";

    return `${preFix}/${runId}`;
  }

  const getCollectionColumns = () => {
    return [
      {
        id: "location",
        Header: "Location",
        accessor: (x) => x.locationName,
      },
      {
        id: "runDate",
        Header: "Expected Delivery Date",
        accessor: (x) => x.runDate,
        maxWidth: 200,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            { row.original.existingRunId > 0 &&
                (<a href={`${BASE_URL}/runs/${getRunUrl(row.original.existingRunId)}`}
                    target={'_blank'}>{moment(row.original.existingTimeStart).format(SHORT_DATE_FORMAT)} -
                  #{row.original.existingRunId}</a>)
            }
          </div>
        ),
      },
      {
        id: "estimate",
        Header: "Estimate",
        accessor: (x) => x.estimatedToReach,
        maxWidth: 130,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {`${
              !row.original.isTinLocation ? `${row.original.estimated}%` : ""
            }`}
          </div>
        ),
      },
      {
        id: "expected",
        Header: "Expected",
        accessor: (x) => x.tinsExpected, // tinsExpected is reused and shared with Collections
        maxWidth: 130,
        align: "center",
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {row.original.tinsExpected} BIBs
          </div>
        ),
      },
      {
        id: "requestUrgent",
        accessor: (x) => x.selected,
        Header: "Request Urgent",
        maxWidth: 160,
        sortable: false,
        Cell: (row) => (
          <div className="flex justify-content-center">            
            <Button
                className={`btn ${getButtonClassName(row.original.locationId)}`}
                onClick={() => handleSelection(row.original.locationId)}
            >
              Request Urgent
            </Button>
          </div>
        ),
      },
    ];
  };
  const getLocationName = () => {
    const location = mustBeArray(list).find(
      (o) => o.locationId === selectedDelivery
    );
    return location && location.locationName;
  };
  return (
    <React.Fragment>
      <Card className="p-1">
        <CardBody>
          <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(list)}
            columns={getCollectionColumns()}
            minRows={
              mustBeArray(list).length === 0
                ? 5
                : mustBeArray(list).length > 20
                ? 20
                : mustBeArray(list).length
            }
            className="selectableRowTable br-1"
            loading={loading}
          />
        </CardBody>
      </Card>
      {selectedDelivery && (
        <Card className="p-1">
          <h5>{`${getLocationName()} - Delivery disclaimer`}</h5>
          <CardBody>
            <React.Fragment>
              <UrgentDeliveryDisclaimer />
              <div className={"ml-2 mt-h flex align-center"}>
                <Input
                  type="checkbox"
                  className="mr-q mb-q"
                  onChange={(e) => handleTermsAgreementChange(e)}
                  checked={conditionAgreed}
                />
                Yes I accept
              </div>
            </React.Fragment>
          </CardBody>
        </Card>
      )}
    </React.Fragment>
  );
};
export default UrgentDeliveries;
